import { render, staticRenderFns } from "./OptionsAfterAddDebtorModal.vue?vue&type=template&id=792a8eaa&"
import script from "./OptionsAfterAddDebtorModal.vue?vue&type=script&lang=js&"
export * from "./OptionsAfterAddDebtorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports